import { render, staticRenderFns } from "./Section09.vue?vue&type=template&id=650be38a&"
import script from "./Section09.vue?vue&type=script&lang=js&"
export * from "./Section09.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports